import { Card, Button } from "react-bootstrap";

const Carrito = ({ carrito, setCarrito }) => {
    const total = carrito.reduce((s, p) => s + p.precio * p.cantidad, 0);

    const vaciar = () => setCarrito([]);

    return (
        <Card className="shadow-sm p-3">
            <h4>🛒 Carrito</h4>
            <hr />

            {carrito.map(item => (
                <div key={item.id} className="d-flex justify-content-between mb-2">
                    <strong>{item.nombre}</strong>
                    <span>x{item.cantidad}</span>
                </div>
            ))}

            <hr />
            <h5>Total: ${total.toLocaleString()}</h5>

            <Button
                className="w-100 mt-3"
                style={{ background: "#722F77", border: "none", borderRadius: "8px" }}
            >
                💳 Pagar
            </Button>

            <Button
                className="w-100 mt-2"
                variant="outline-danger"
                onClick={vaciar}
            >
                🗑 Vaciar
            </Button>
        </Card>
    );
};

export default Carrito;